"use client";
import React, { useEffect, useRef, useState } from "react";
import dynamic from "next/dynamic";
import clsx from "clsx";
import Markdown from "@/components/atoms/Markdown";
import besocial from '~/icons/besocial.webp'


import styles from "./WhyAmity.module.scss";

const DiverseLeaningMediums = dynamic(() => import("@/SvgIcons/DiverseLearningMediums"));
const DedicatedAcademicAdvisor = dynamic(() => import("@/SvgIcons/DedicatedAcademicAdvisor"));
const AIProfessional = dynamic(() => import("@/SvgIcons/AIProfessor"));
const OfflineExperience = dynamic(() => import("@/SvgIcons/OfflineExperiences"));
const PlacementOpportunities = dynamic(() => import("@/SvgIcons/PlacementOpportunities"));
const CarreerServices = dynamic(() => import("@/SvgIcons/CareerServices"));
const LMS = dynamic(() => import("@/SvgIcons/LMS"), { ssr: false });

const SVG_DATA = [
  {
    heading: "WASC Accreditation (USA)",
    subHeading:
      "Amity Online is India's only university accredited by the Western Association of Schools and Colleges  — a distinguished recognition of global academic excellence.",
      src:`https://amityonline.com/_s/WASC_fb7127e339.webp`,
    type:"PNG" 
  },
  {
    heading: "WES Recognition",
    subHeading:
      "Degrees recognised by World Education Services (WES) Canada & USA, enabling smoother pathways for higher studies and global career mobility.",
      src:"https://amityonline.com/_s/Group_48099252_1_df96398b17_8a67bc8d63_b0fc08c271.webp",
    type:"PNG" 
  },
  {
    heading: "QS Ranked Online MBA",
    subHeading:
      "Amity Online offers India's only Online MBA ranked by QS under Asia Pacific Top 10 - a global recognition for academic strength, learner outcomes, and digital innovation.",
      src:'https://amityonline.com/_s/Group_48099254_1_46922cfc87_920634f33f.webp',
    type:"PNG" 
  },
  {
    heading: "QAA (UK) Accreditation",
    subHeading:"Accredited by the UK's Quality Assurance Agency (QAA), assuring students of globally benchmarked academic quality.",
    src:"https://amityonline.com/_s/qaa_44482cac1e.webp",
    type:"PNG" ,
    style:'!w-[6rem]'
  },
  {
    heading: "Times Higher Education Employability Rankings",
    subHeading:
      "Amity University is ranked among the best globally for graduate employability and employer reputation by Times Higher Education.",
      src:'https://amityonline.com/_s/Times_Higher_Education_logo_1_1_f1dd81080b.webp',
    type:"PNG" ,
    style:'!w-[7rem]'
  },
  {
    heading: "Pan-India Campus Access & Offline Events",
    subHeading:
      "Enjoy access to all Amity campuses for events like orientation, mid-year meetups, on-campus connect and convocation - blending digital convenience with real-world connection.",
    component: OfflineExperience,
    type:"SVG" 
  },
  {
    heading: "Amigo: Learning On-the-Go",
    subHeading:
      "The Amigo app makes learning seamless and mobile — attend live classes, track progress, access materials, and more on your schedule.",
    component: LMS,
    type:"SVG" 
  },
  {
    heading: "Prof. Ami: Your AI-Powered Personal Tutor",
    subHeading:
      "Meet Prof. Ami — your always-on, AI mentor for instant doubt-solving, personalised learning tips, and smart academic support.",
    component: AIProfessional,
    type:"SVG" 
  },
  {
    heading: "Industry Certifications for Better Employability",
    subHeading:
      "Gain an edge with in-demand certifications from top industry bodies and partners — integrated within your program to boost your skills and CV.",
    component: DiverseLeaningMediums,
    type:"SVG" 
  },
  {
    heading: "Internship Opportunities",
    subHeading:
      "Access curated internships with leading companies through our corporate network, helping you gain real-world experience and stand out in the job market.",
    component: PlacementOpportunities,
    type:"SVG" 
  },
  {
    heading: "AI-Powered Career Discovery Platform",
    subHeading:
      "From mock interviews and resume building to job search and easy-apply tools — our AI-powered platform ensures you’re career-ready from day one.",
    component: CarreerServices,
    type:"SVG" 
  },
  {
    heading: "beSocial App for Campus Life",
    subHeading:
      "Your virtual student hub — the beSocial app lets you network, join clubs, attend events, and be part of a vibrant, online-first community.",
      src:'https://amityonline.com/_s/besocial_1_1db313ae01.webp',
    type:"PNG" 
  },
];

const IntersectionObserverWrapper = ({ children }) => {
  const [isIntersecting, setIntersecting] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) =>
      entry.isIntersecting ? setIntersecting(entry.isIntersecting) : null
    );
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className={styles.intersectionDiv} ref={ref}>
      {isIntersecting ? children : null}
    </div>
  );
};

export default function WhyAmityItemClientWrapper() {
  return (
    <>
      {SVG_DATA.map(({ heading, subHeading, component, type, src,style }) => {
        const SVGComp = component;

        return (
          <React.Fragment key={heading}>
            <div className={clsx("font-raleway", styles.item, styles.centerdItem)}>
              <div className={styles.wrapperIntersection}>
                <IntersectionObserverWrapper>
                  {type === "SVG" ? (
                    <SVGComp />
                  ) : (
                    <img className={style} src={src}  alt={heading} loading="lazy" />
                  )}
                </IntersectionObserverWrapper>
              </div>

              <Markdown as="h3" className={styles.title}>
                {heading}
              </Markdown>

              <p className={clsx("text-sec", styles.subtitle)}>{subHeading}</p>
            </div>
          </React.Fragment>
        );
      })}
    </>
  );
}
